export class ApiResponseError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly status: number,
    public readonly details?: Record<string, string[]>,
  ) {
    super(message);
    this.name = 'ApiResponseError';
  }
}

export async function fetchApi<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const body = await res.json().catch(() => ({
      error: { message: 'Request failed', code: 'UNKNOWN' },
    }));
    throw new ApiResponseError(
      body.error?.message ?? 'Request failed',
      body.error?.code ?? 'UNKNOWN',
      res.status,
      body.error?.details,
    );
  }
  return res.json() as Promise<T>;
}
